import { Divider } from 'primereact/divider';
import { useEffect, useMemo, useState } from 'react';
import { endpointFundDocumentUrlGET } from '~/api/def/endpoints/document';
import { PDFContainer } from '~/components/ui/vendor/pdf/pdf_container';
import { fieldsToPDFHighlights } from '~/lib/pdfViewer/fieldsToPDFHighlights';
import { DocumentPDFField } from '~/lib/pdfViewer/types';
import { DocumentOverviewCapTable } from '../tables/ag/DocumentOverviewCapTable/DocumentOverviewCapTable';

type DocumentCapTableContainerProps = {
  documentId: string;
  portfolioCompanyId: string;
};

export default function DocumentCapTableContainer({
  documentId,
  portfolioCompanyId,
}: DocumentCapTableContainerProps) {
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState('');
  const [pdfFields, setPdfFields] = useState<DocumentPDFField[]>();
  const [scrolledHighlight, scrollToHighlight] = useState<string | null>(null);
  const highlights = useMemo(() => {
    const fieldHighlights = pdfFields ? fieldsToPDFHighlights(pdfFields) : [];
    return [...fieldHighlights];
  }, [pdfFields]);

  useEffect(() => {
    endpointFundDocumentUrlGET(documentId)
      .then((res) => {
        setSelectedDocumentUrl(res?.data.presignedUrl || '');
      })
      .catch((err) => {
        console.log(err);
      });
  }, [documentId]);

  return (
    <div className="flex flex-column gap-3 align-item-center h-full">
      <div
        style={{
          height: '45%',
          marginLeft: '1rem',
        }}
      >
        <>
          {selectedDocumentUrl && (
            <PDFContainer
              url={selectedDocumentUrl}
              enableAreaSelection={function (): boolean {
                throw new Error('Function not implemented.');
              }}
              highlights={highlights}
              activeHighlight={scrolledHighlight}
            />
          )}
        </>
      </div>
      <Divider />
      <div style={{ height: '45%' }}>
        <DocumentOverviewCapTable
          documentId={documentId}
          portfolioCompanyId={portfolioCompanyId}
          scrollToHighlight={scrollToHighlight}
          setPdfFields={setPdfFields}
        />
      </div>
    </div>
  );
}
